import React from 'react';
import { domToReact } from 'html-react-parser';
import styled from 'styled-components';

const StyledP = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;

const pTagRenderer = (node) => {
  const { children, options } = node;

  return (<StyledP>
    {domToReact(children, options)}
  </StyledP>);
};

export default pTagRenderer;
